module.exports = __webpack_public_path__ + "static/media/review-logo.2f88b99f.svg";